module.exports = __webpack_public_path__ + "static/media/img_logo_point.8d324c47.png";